import React, { useEffect, useMemo, useState } from "react";
import styles from "../../PagesStyles/AdminPurchaseEntryNew.module.css";
import AdminHeading from "../Heading/AdminHeading";
import AlertMessage from "Components/Other Functions/AlertMessage";
import { ClipLoader } from "react-spinners";
import ErrorModal from "Components/Other Functions/popup";
import { useNavigate } from "react-router-dom";
import { toPlainFields } from "Components/support/Allfields/fieldconverter";
import {
    InvoiceEntryNewFields,
  PurchaseEntryFields,
  PurchaseEntryNewFields,
} from "Components/support/Allfields/purchasefields";
import { useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { RiAddBoxFill } from "react-icons/ri";
import { IoMdRefresh } from "react-icons/io";
import { GoTrash } from "react-icons/go";
import { Icon } from "@iconify/react";
import Summary from "Components/AdminPurchaseEntryNew/Summary";
import SkuForm from "Components/AdminPurchaseEntryNew/SkuForm";
import { useQuery } from "@tanstack/react-query";
import GetApiService from "Components/Api/getapiService";
import { getAllPaymentMethod } from "utils/helpers";
import toast from "react-hot-toast";
import PaymentModeForm from "Components/AdminPurchaseEntryNew/PaymentModeForm";
import { FaCalendarAlt } from "react-icons/fa";
import Select from "react-select";


const purchaseProductDefault = {
  StockKeepingUnit: "",
  ItemCode: "",
  MakingFixedAmt: 0,
  MakingPerGram: 0,
  MakingFixedWastage: 0,
  MakingPercentage: 0,
  MetalRate: 0,
  FinePercent: 0,
  WastagePercent: 0,
  Quantity: 1,
  PurityId: 0,
  CategoryId: 0,
  ProductId: 0,
  DesignId: 0,
  FineGoldWt: 0,
  FineSilverWt: 0,
  TotalFineGold: "",
  FineOtherMetalWt: 0,
  TotalStoneAmt: 0,
  TotalItemAmt: 0,
  FineWt: 0,
  WastageWt: 0,
  FineWastageWt: 0,
  RDPurchaseId: 0,
  CategoryName: "",
  ProductName: "",
  DesignName: "",
  GrossWt: 0,
  NetWt: 0,
  StoneWt: 0,
  Status: "Active",
  CounterId: 0,
  BranchId: 0,
  CompanyId: 0,
  FinePure: false,
  ClientCode: 0,
  AddToUnlabelled: false,
  MetalId: 0,
  MetalName: "",
  StoneName: "",
  StoneWeight: 0,
  StonePieces: 0,
  StoneRate: 0,
  StoneAmount: 0,
  HallmarkAmt: 0,
  TagWeight: 0,
  FindingWeight: 0,
  LanyardWeight: 0,
  Testing: "0",
  Stones: [],
  Diamonds: [],
  ConvertAmount: true,
  MRP: "0",
  ClipWeight: "0",
  ClipQuantity: "0",
  DiamondName: "",
  DiamondWeight: 0,
  DiamondRate: 0,
  DiamondPieces: 0,
  DiamondAmount: 0,
  DiamondSize: "0",
  DiamondPurchaseRate: "0",
  DiamondSellRate: "0",
  DiamondClarity: "",
  DiamondColour: "",
  DiamondShape: "",
  DiamondCut: "",
  DiamondSettingType: "",
  DiamondCertificate: "",
  DiamondPurchaseAmount: "0",
  DiamondSellAmount: "0",
  DiamondDescription: "",
  status:"paid",
  skus: [],
  paymentTypes:[
    { id: 1, mode: "Cash", amount: 1000, gold: 20, silver: 30 },
    
  ],
  balanceGold:"",
  taxableAmount:"",
  gst:"",
  paidAmount:"",
  advanceAmount:"",
  balanceSilver:"",
  RODiscount:"",
  totalAmount:"",
  balanceAmount:""
};

const AdminWholeSaleEntryNew = () => {
  const navigate = useNavigate();
 

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false); // Modal visibility state
  const [errorMessage, setErrorMessage] = useState(null);
  const [active, setActive] = useState("AddNew");
  const [messageToShow, setMessageToShow] = useState("");
  const [messageType, setMessageType] = useState("");
  const [showError, setShowError] = useState(false);
  const [isSummaryOpen, setIsSummaryOpen] = useState(true);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  const clientCode = adminLoggedIn.ClientCode;
  const apiService = new GetApiService(clientCode);

  const fetchData = async()=>{
    try{
        const data = await apiService.fetchAllCustomers()
        return data
    }catch(e){
        console.log(e)
    }
  }
  const {
    data: vendorlist,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["vendorlist"],
    queryFn: fetchData,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    staleTime: 1000 * 60 * 2,
  });
  const apifields = useMemo(
    () =>
      adminLoggedIn.Modules.filter(
        (module) => module.PageName === "purchase_entry"
      ),
    [adminLoggedIn]
  );
  const localfields = useMemo(() => toPlainFields(InvoiceEntryNewFields), []);
  const apifieldsControls = useMemo(
    () => apifields[0]?.PageControls || [],
    [apifields]
  );

  const [itemfields, setItemfields] = useState(() =>
    localfields.map((localField) => {
      const matchingApiField = apifieldsControls.find(
        (apiField) => apiField.key === localField.key
      );
      if (matchingApiField) {
        return {
          ...localField,
          label: matchingApiField.label,
          placeholder: matchingApiField.placeholder,
          priority: matchingApiField.priority,
          type: matchingApiField.type,
          visibility: matchingApiField.visibility,
          place: matchingApiField.place,
        };
      }
      return localField;
    })
  );

  const [purchaseProduct, setPurchaseProduct] = useState(
    purchaseProductDefault
  );
  const [editValues,setEditValues] = useState()
  const [edit,setEdit] = useState(false)
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: purchaseProduct,
  });
  const specificField = watch("StockKeepingUnit");
  const skus = watch("skus");
  const paymentTypes = watch("paymentTypes");
  const inputPaymentMode = watch("inputPaymentMode");









  const handleSkuInputChange = (e) => {
    e.preventDefault();
    const { value } = e.target;
    setSelectedSkuName(value);
    if (value !== "") {
      let selectedSkuItem = [];
      selectedSkuItem = allSkuList.find((x) => x.StockKeepingUnit == value);
      console.log(selectedSkuItem, "selectedSkuItem");
      // if (selectedSkuItem) {
      if (selectedSkuItem) {
        setSelectedSku(selectedSkuItem);
        console.log(selectedSkuItem, "selectedSkuItem");
        console.log(selectedSkuItem, "selectedSkuItem");
      }
    } else {
      let selectedSkuItem = [];
      setSelectedSku(selectedSkuItem);
    }
    // setSelectedCategory(selectedSkuItem.category);
    // setSelectedProductType(selectedSkuItem.productType);
    // }
  };

  const reloadData = () => {
    setShowModal(false); // Close the modal
    // loadData();
  };

  const addSku = (data) => {
    setValue("skus", [
      ...skus,
      {
        id: Date.now(),
        ...data,
      },
    ]);
    setIsSummaryOpen(true);
  };

  const updateSku = (data)=>{
    setValue(
        "skus",
        skus.map((sku) => (sku.id === data.id ? data : sku)) // Replace only the matching SKU
      );
    setEditValues()
    setEdit(false)
    setIsSummaryOpen(true);  
  }
  const addPaymentMode = (data)=>{
    setValue("paymentTypes",[
        ...paymentTypes,
        {
            id:Date.now(),
            ...data
        }
    ])
  }
  const onSubmit = (data) => {
    if(!skus.length){
        toast.error("Atleast one item needed");
    }
  };


  return (
    <>
      <div>
        <AdminHeading />
        {loading ? (
          // Show spinner while loading
          <div className="spinner-container">
            <ClipLoader size={50} color={"#123abc"} loading={loading} />
            <p>Loading data...</p>
          </div>
        ) : (
          <>
            <div>
              <ErrorModal
                isOpen={showModal}
                onRequestClose={() => {
                  setShowModal(false); // Close the modal
                  navigate("/adminhome"); // Redirect to /adminhome
                }}
                onReload={reloadData} // Pass reload function
                message={errorMessage}
              />

              <div className="adminMainBodyBox">
                {showError ? (
                  <AlertMessage message={messageToShow} type={messageType} />
                ) : null}
              </div>
            </div>
          </>
        )}
      </div>
    
      <form onSubmit={handleSubmit(onSubmit)} className={styles.mainbox}>
      
        {/*basic detail section */}
        <div className={styles.linesection}>
      <div className={styles.infoline}>
        <div style={{ display: "flex" }}>
          <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
            <label>Invoice No</label>
            <input
              {...register("invoiceNumber")}
              style={{ width: "60%" }}
            />
          </div>
        </div>
        <div className={styles.dateSection}>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <label htmlFor="invoiceDate">Date</label>
            <div style={{ position: "relative", display: "inline-block" }}>
      <input
        id="invoiceDate"
        type="date"
        
        {...register("invoiceDate")}
        style={{
          width: "100%",
          padding: "5px 10px",
          paddingRight: "30px",
          borderRadius: "4px",
          border: "1px solid #ccc",
          appearance: "none",
          WebkitAppearance: "none",
          MozAppearance: "none",
        }}
      />
    
    </div>
          </div>
        </div>
      </div>
    </div>

        {/* top section */}
       
        <div className={styles.linesection}>
          <div className={styles.container}>
            {itemfields
              ?.filter((field) => field?.place === "top")
              .sort((a, b) => a.priority - b.priority)
              .map((field, index) => (
                <div className={styles.box}>
                  <label>{field.label}</label>
                  {field.type === "inputselect" ? (
                    // SKU Input with datalist
                    <input
                      type="text"
                      name={field.key}
                      placeholder={`Enter ${field.label}`}
                      disabled={field.visibility === "ReadOnly"}
                      {...register(field.key, {
                        required: `${field.label} is required`,
                      })}
                      list="skuList"
                      autoComplete="off"
                    />
                  ) : field.type === "dropdown" ? (
                    <Controller
                      name={field.key}
                      control={control}
                      rules={{
                        required: `${field.label} is required`,
                      }}
                      render={({ field: controllerField, fieldState: { error } }) => (
                        <select
                          {...controllerField}
                          disabled={field.visibility === "ReadOnly"}
                        >
                          <option value="">-- select --</option>
                          {(field.key === "VendorName"
                            ? vendorlist
                            : []
                          )?.map((x) => (
                            <option
                              key={x.Id}
                              value={`${x.Id},${x.VendorName}`}
                            >
                              {x.VendorName}
                            </option>
                          ))}
                        </select>
                      )}
                    />
                  ) :  field.type === "searchDropdown" ? (

                    <Controller
                    name={field.key}
                    control={control}
                    rules={{
                      required: `${field.label} is required`,
                    }}
                    render={({ field: controllerField, fieldState: { error } }) => (
                      <Select
                      {...controllerField}
                      options={
                        field.key === "VendorName"
                          ? vendorlist?.map((vendor) => ({
                              value: `${vendor.Id},${vendor.VendorName}`,
                              label: vendor.VendorName,
                            }))
                          : []
                      }
                      isDisabled={field.visibility === "ReadOnly"}
                      isSearchable
                      placeholder="-- select --"
                    />
                    )}
                  />
                  ): field.type === "number" || field.type === "text" ? (
                    // Number input field
                    <input
                      name={field.key}
                      type={field.type}
                      placeholder={`Enter ${field.label}`}
                      {...register(field.key, {
                        required:
                          field.visibility !== "ReadOnly" &&
                          `${field.label} is required`,
                        pattern: field.type === "number" ? /^\d+$/ : undefined,
                      })}
                      disabled={field.visibility === "ReadOnly"}
                    />
                  ) : null}
                  {errors[field.key] && (
                    <span className={styles.fielderror}>
                      {errors[field.key].message}
                    </span>
                  )}
                </div>
              ))}
          </div>
        </div>
        {isSummaryOpen ? (
          <div className={styles.summarySection}>
            <Summary 
            skus={skus} 
            setIsSummaryOpen={setIsSummaryOpen}
            setValue={setValue}
            setEditValues={setEditValues}
            setEdit={setEdit}
            />
          </div>
        ) : (
          <>
            {/* middle section */}
            <div style={{ display: "flex", alignItems: "center", gap: "20px",padding:"0px 20px" }}>
          <label>Old Gold Purchase</label>
          <div className={styles.switch}>
            {/* <input
              type="checkbox"
              id="toggleSwitch"
              className={styles.switchinput}
              checked={isToggled}
              onChange={() => setIsToggled(!isToggled)}
            /> */}
            <input
              type="checkbox"
              id="toggleSwitch"
              className={styles.switchinput}
              {...register("oldGoldPurchase")}
            />
            <label
              className={styles.switchlabel}
              htmlFor="toggleSwitch"
            ></label>
          </div>
        </div>
            <SkuForm
              isInvoiceEntry={true}
              itemfields={itemfields}
              editValues={editValues} 
              edit={edit}
              updateSku={updateSku}
              addSku={addSku}
              isSummaryOpen={isSummaryOpen}
              setIsSummaryOpen={setIsSummaryOpen}
            />
          </>
        )}

        {/* bottom section */}
        <div className={styles.linesection}>
          {/* custom bar */}
          {/* {false ? (
            <></>
          ):(<>
          <div className={styles.custombarlinehead}>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <label>Add this product to unlabeled stock</label>
              <div className={styles.switch}>
                <input
                  type="checkbox"
                  id="toggleSwitch"
                  className={styles.switchinput}
                  checked={isToggled}
                  onChange={() => setIsToggled(!isToggled)}
                />
                <label
                  className={styles.switchlabel}
                  htmlFor="toggleSwitch"
                ></label>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <button
                type="button"
                style={{
                  padding: "4px 8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  fontSize: "14px",
                  backgroundColor: "#0077d4",
                }}
                
                onClick={handleAddSku}
              >
                <Icon
                  style={{ fontSize: "24px" }}
                  icon="fluent:add-32-filled"
                />
                Add
              </button>
              <button
                type="button"
                style={{
                  fontSize: "14px",
                  backgroundColor: "#0077d4",
                  padding: "4px 8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
                onClick={()=>setIsSummaryOpen(!isSummaryOpen)}
              >
                <Icon style={{ fontSize: "24px" }} icon="solar:list-bold" />
                Summary
              </button>
            </div>
          </div>
          </>)}
           */}

          {/* calculations section */}
          <div className={styles.calculation}>
            {/* Left Section */}

            <div className={styles.calculationleft}>
              <div className={styles.radioBar}>
                <label className={styles.radioLabel}>
                  <input
                    type="radio"
                    value="paid"
                    {...register("status", {
                      required: "Please select an option",
                    })}
                  />
                  Paid
                </label>
                <label className={styles.radioLabel}>
                  <input
                    type="radio"
                    value="received"
                    {...register("status", {
                      required: "Please select an option",
                    })}
                  />
                  Received
                </label>
              </div>




             
              <PaymentModeForm addPaymentMode={addPaymentMode}/>







              <div className={styles.tableContainer}>
                <table className={styles.table}>
                  <thead>
                    <tr>
                      <th>Sr No</th>
                      <th>Mode</th>
                      <th>Amount</th>
                      <th>Gold</th>
                      <th>Silver</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentTypes.map((row, index) => (
                      <tr key={row.id}>
                        <td>{index + 1}</td>
                        <td>{row.mode}</td>
                        <td>{row.amount}</td>
                        <td>{row.gold}</td>
                        <td>{row.silver}</td>
                        <td>
                          <GoTrash
                            style={{cursor:"pointer"}}
                            onClick={() => {
                                setValue(
                                    "paymentTypes",
                                    paymentTypes.filter((paymentType) => paymentType.id !== row.id)
                                  );
                            }}
                            size={24}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Right Section */}
            <div className={styles.calculationright}>
              <div className={styles.totalLeft}>
                <div className={styles.amountField}>
                  <label>Balance Gold (F + W)</label>
                  <input
                    type="text"
                    {...register("balanceGold")}
                  />
                </div>
                <div className={styles.amountField}>
                  <label>Taxable Amount</label>
                  <input
                    type="text"
                    {...register("taxableAmount")}
                  />
                </div>
                <div className={styles.amountField}>
                  <label>GST(3%)</label>
                  <input
                    type="text"
                    {...register("gst")}
                  />
                </div>
                <div className={styles.amountField}>
                  <label>Paid Amount</label>
                  <input
                    type="text"
                    {...register("paidAmount")}
                  />
                </div>
                <div className={styles.amountField}>
                  <label>Advance Amount</label>
                  <input
                    type="text"
                    {...register("advanceAmount")}
                  />
                </div>
              </div>

              <div className={styles.totalRight}>
                <div className={styles.amountField}>
                  <label>Balance Silver (F + W)</label>
                  <input
                    type="text"
                    {...register("balanceSilver")}
                  />
                </div>
                <div className={styles.amountField}>
                  <label>R.O./Discount(-)</label>
                  <input
                    type="text"
                    {...register("RODiscount")}
                  />
                </div>
                <div className={styles.amountField}>
                  <label>Total Amount</label>
                  <input
                    type="text"
                    {...register("totalAmount")}
                  />
                </div>
                <div className={styles.amountField}>
                  <label>Balance Amount</label>
                  <input
                    type="text"
                    {...register("balanceAmount")}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* {errors.status && (
            <p className={styles.error}>{errors.status.message}</p>
          )} */}
        </div>
        <button type="submit">save</button>
      </form>
    </>
  );
};

export default AdminWholeSaleEntryNew;
